/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TrendValue,
  TrendValue$inboundSchema,
  TrendValue$Outbound,
  TrendValue$outboundSchema,
} from "./trendvalue.js";

export const AggType = {
  Avg: "avg",
  Max: "max",
  Min: "min",
  First: "first",
  Last: "last",
} as const;
export type AggType = OpenEnum<typeof AggType>;

/**
 * Data availability status for this source.
 */
export const QueryTrendSourceResultStatus = {
  Data: "data",
  NoData: "no_data",
} as const;
/**
 * Data availability status for this source.
 */
export type QueryTrendSourceResultStatus = OpenEnum<
  typeof QueryTrendSourceResultStatus
>;

/**
 * Query result for a single source.
 */
export type QueryTrendSourceResult = {
  aggType: AggType;
  /**
   * Data availability status for this source.
   */
  status?: QueryTrendSourceResultStatus | undefined;
  /**
   * The trend values for this source.
   */
  values: Array<TrendValue>;
};

/** @internal */
export const AggType$inboundSchema: z.ZodType<AggType, z.ZodTypeDef, unknown> =
  openEnums.inboundSchema(AggType);
/** @internal */
export const AggType$outboundSchema: z.ZodType<string, z.ZodTypeDef, AggType> =
  openEnums.outboundSchema(AggType);

/** @internal */
export const QueryTrendSourceResultStatus$inboundSchema: z.ZodType<
  QueryTrendSourceResultStatus,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(QueryTrendSourceResultStatus);
/** @internal */
export const QueryTrendSourceResultStatus$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  QueryTrendSourceResultStatus
> = openEnums.outboundSchema(QueryTrendSourceResultStatus);

/** @internal */
export const QueryTrendSourceResult$inboundSchema: z.ZodType<
  QueryTrendSourceResult,
  z.ZodTypeDef,
  unknown
> = z.object({
  agg_type: AggType$inboundSchema,
  status: QueryTrendSourceResultStatus$inboundSchema.default("data"),
  values: z.array(TrendValue$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "agg_type": "aggType",
  });
});
/** @internal */
export type QueryTrendSourceResult$Outbound = {
  agg_type: string;
  status: string;
  values: Array<TrendValue$Outbound>;
};

/** @internal */
export const QueryTrendSourceResult$outboundSchema: z.ZodType<
  QueryTrendSourceResult$Outbound,
  z.ZodTypeDef,
  QueryTrendSourceResult
> = z.object({
  aggType: AggType$outboundSchema,
  status: QueryTrendSourceResultStatus$outboundSchema.default("data"),
  values: z.array(TrendValue$outboundSchema),
}).transform((v) => {
  return remap$(v, {
    aggType: "agg_type",
  });
});

export function queryTrendSourceResultToJSON(
  queryTrendSourceResult: QueryTrendSourceResult,
): string {
  return JSON.stringify(
    QueryTrendSourceResult$outboundSchema.parse(queryTrendSourceResult),
  );
}
export function queryTrendSourceResultFromJSON(
  jsonString: string,
): SafeParseResult<QueryTrendSourceResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => QueryTrendSourceResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'QueryTrendSourceResult' from JSON`,
  );
}
